import { isNativeApp } from './isNativeApp';

export const APP_PREFIX = '/app';

export function appPath(pathname) {
  if (!isNativeApp()) return pathname;
  if (!pathname || typeof pathname !== 'string') return pathname;
  if (!pathname.startsWith('/')) return pathname;
  if (pathname.startsWith(APP_PREFIX)) return pathname;
  return `${APP_PREFIX}${pathname}`;
}
